export const HELP_DRAWER_SELECT_LAYER_CLASS = 'help-drawer-select-layer'
